import React from 'react';

import { Container } from 'native-base';

import type { IGridProps } from './Grid.types';

const Grid = (props: IGridProps, ref: any) => {
  return (
    <Container
      maxWidth={{ lg: '904px', xl: '1440px' }}
      px={{ lg: '8', xl: '120px' }}
      ref={ref}
      {...props}
    />
  );
};

export default React.memo(React.forwardRef(Grid));
